import { useEffect, useState } from 'react';

type OT = {
  hasMediaProcessorSupport: () => boolean;
};

/**
 *  Sadly SSR prevents importing this due to the library relying on window usage
 */
export const useHasMediaProcessorSupport = (): boolean => {
  const [hasMediaProcessorSupport, setHasMediaProcessorSupport] =
    useState(false);

  useEffect(() => {
    import('@opentok/client')
      .then((module: OT) => {
        setHasMediaProcessorSupport(module.hasMediaProcessorSupport());
        return null;
      })
      .catch((err) => {
        console.error(
          '[useHasMediaProcessorSupport]: Failed to load module:',
          err,
        );
      });
  }, []);

  return hasMediaProcessorSupport;
};
